const DATE_REGEX = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/g;

export const parseStringWithDate = (
  val: string,
  formatDate: (date: string | Date, format?: string) => string,
  customFormat: string = 'P p'
) => {
  return val.replace(DATE_REGEX, (date) => formatDate(date, customFormat));
};
